import React from 'react';
import styles from './Thumbnail.module.scss';
import placeholderImage from './placeholderImage.png';
import useMusicContextMenu from '../../../../../hooks/useMusicContextMenu';

export interface Props {
  id: string;
  name: string;
  artistName: string | null;
  image?: string;
  album?: boolean;
  playlist?: boolean;
  resourceType:
    | 'catalog-album'
    | 'library-album'
    | 'catalog-playlist'
    | 'library-playlist';
  onClick(target: any): void;
}

export function Thumbnail({
  id,
  name,
  artistName,
  image,
  resourceType,
  onClick,
}: Props) {
  const {Popover, popoverProps, onContextMenu} = useMusicContextMenu({
    id,
    resourceType,
  });
  const alt = artistName ? `${name}, ${artistName}` : `${name}`;
  const finalImage = image ? image : placeholderImage;

  return (
    <div>
      <Popover {...popoverProps}>
        <div className={styles.Thumbnail}>
          <button
            className={styles.Button}
            onClick={() => onClick(0)}
            onContextMenu={onContextMenu}
          >
            <div className={styles.ContentWrapper}>
              <div className={styles.ImageWrapper}>
                <img className={styles.Image} alt={alt} src={finalImage} />
              </div>
              <div className={styles.HoverContent}>
                <div className={styles.HoverTitle}>{name}</div>
                <div className={styles.HoverArtist}>{artistName}</div>
              </div>
            </div>
          </button>
        </div>
      </Popover>
    </div>
  );
}
